import { render, staticRenderFns } from "./AddTeamComponent.vue?vue&type=template&id=4d292718&"
import script from "./AddTeamComponent.vue?vue&type=script&lang=js&"
export * from "./AddTeamComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports